import "@/lib/sentry-browser";
import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { handleInvalidSession, isAuthError, isSessionSupersededError } from "@/lib/auth/invalid-session";
import { watchFirstPageRender } from "@/lib/first-page-render";

function reasonFor(error: unknown) {
  return isSessionSupersededError(error) ? "superseded" as const : "unknown" as const;
}

export const getRouter = () => {
  const queryClient = new QueryClient({
    queryCache: new QueryCache({
      onError: (error) => {
        if (isAuthError(error)) {
          void handleInvalidSession(reasonFor(error));
        }
      },
    }),
    mutationCache: new MutationCache({
      onError: (error) => {
        if (isAuthError(error)) {
          void handleInvalidSession(reasonFor(error));
        }
      },
    }),
    defaultOptions: {
      queries: {
        retry: (failureCount, error) => {
          if (isAuthError(error)) {
            void handleInvalidSession(reasonFor(error));
            return false;
          }
          return failureCount < 2;
        },
      },
    },
  });

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
  });

  // Vor dem Hydrieren anmelden: Die Sprachumschaltung wartet auf dieses Signal.
  watchFirstPageRender(router);

  return router;
};
